import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Spinner,
  makeStyles,
} from "@fluentui/react-components";
import { ChevronDownFilled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

// Matches ButtonSize from the Button component in fluentui.
declare type ButtonSize = "small" | "medium" | "large";

interface SaveSplitButtonProps {
  saveText: string;
  onSave: (event: unknown) => void;
  isSaveLoading: boolean;
  saveDisabled?: boolean;
  size?: ButtonSize;
  showSaveAndPublishOption: boolean;
  saveAndPublishText: string;
  onSaveAndPublish: () => void;
  saveAndPublishDisabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
  },
  saveButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  chevronButton: {
    minWidth: "unset",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "1px solid rgba(255, 255, 255, 0.3)",
  },
});

export const SaveSplitButton = ({
  saveText,
  onSave,
  isSaveLoading,
  saveDisabled,
  size,
  showSaveAndPublishOption,
  saveAndPublishText,
  onSaveAndPublish,
  saveAndPublishDisabled,
}: SaveSplitButtonProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const saveIcon =
    isSaveLoading && !saveDisabled ? <Spinner size="tiny" /> : null;

  if (!showSaveAndPublishOption) {
    return (
      <Button
        size={size}
        appearance="primary"
        onClick={onSave}
        disabled={saveDisabled}
        disabledFocusable={isSaveLoading}
        icon={saveIcon}
      >
        {saveText}
      </Button>
    );
  }

  return (
    <div className={classes.root}>
      <Button
        className={classes.saveButton}
        size={size}
        appearance="primary"
        onClick={onSave}
        disabled={saveDisabled}
        disabledFocusable={isSaveLoading}
        icon={saveIcon}
      >
        {saveText}
      </Button>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button
            className={classes.chevronButton}
            size={size}
            appearance="primary"
            icon={<ChevronDownFilled />}
            aria-label={t("saveOptionsButtonLabel")}
            disabled={saveAndPublishDisabled}
          />
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            <MenuItem onClick={onSaveAndPublish}>{saveAndPublishText}</MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};
